// BEGIN ZHONGSOFT: public-search — 二开路由集中管理（从 routes.tsx 提取）
//
// 将二开页面的路由枚举和路由配置统一放在此文件，
// routes.tsx 中只需一行 import + 一行展开，减少上游文件修改行数。
//

import type { LazyRouteConfig } from './routes';

export const KnowledgeSearchRoutePath = '/knowledge-search' as const;
export const KnowledgeAssistantRoutePath = '/knowledge-assistant' as const;

export const zhongsoftRouteConfigs: LazyRouteConfig[] = [
  {
    path: KnowledgeSearchRoutePath,
    Component: () => import('@/pages/knowledge-search'),
    layout: false,
  },
  {
    path: KnowledgeAssistantRoutePath,
    Component: () => import('@/pages/knowledge-assistant'),
    layout: false,
  },
  // 免登录文档预览页面，兼容低版本浏览器
  {
    path: '/document-view/:id',
    Component: () => import('@/pages/document-view'),
    layout: false,
  },
];
// END ZHONGSOFT
